// Customers' search (QA-063): what's typed and the Show filter, asked of customers.list a moment after
// the typing stops; only the latest answer is shown, and until it's in the search is still on its way.
// Riverstone's Search and Blueprint's All customers (FindCustomers.tsx) both read it.
import { useEffect, useState } from 'react';
import { RpcError } from '@flowology/client';
import { client } from '../api.ts';
import { seesOwing, type ListRow, type ListShow } from './bp-customers-model.ts';

const message = (e: unknown) =>
  e instanceof RpcError || e instanceof Error ? e.message : 'Something went wrong.';

export function useCustomerSearch() {
  const [query, setQuery] = useState('');
  const [rows, setRows] = useState<ListRow[]>([]);
  // Blueprint's show filter (customers.list `show`); Riverstone never sends one
  const [show, setShow] = useState<ListShow>('all');
  // told what people owe once any answer says it, so Owe money is offered only to those who see it
  const [moneyShown, setMoneyShown] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // The search the rows answer: until the latest one is answered it is still loading (QA-063).
  const [answered, setAnswered] = useState<string | null>(null);
  const asked = `${show}|${query}`;
  useEffect(() => {
    let current = true;
    const t = setTimeout(() => {
      client
        .call<{ customers: ListRow[] }>('customers.list', {
          query: query.trim() || undefined,
          limit: 25,
          ...(show !== 'all' ? { show } : {}),
        })
        .then((r) => {
          if (!current) return; // a later search is on its way
          setRows(r.customers);
          if (seesOwing(r.customers)) setMoneyShown(true);
          setAnswered(asked);
          setError(null);
        })
        .catch((e: unknown) => current && setError(message(e)));
    }, 200);
    return () => {
      current = false;
      clearTimeout(t);
    };
  }, [query, show]);
  return {
    query,
    setQuery,
    show,
    setShow,
    rows,
    moneyShown,
    error,
    /** The search the rows answer; a new one starts the list at five again. */
    answered,
    searching: answered !== asked && !error,
  };
}
